import React from "react";
import Breadcrumb from "../components/Breadcrumb";

export default function FAQs() {
  return (
    <>
      <Breadcrumb title="FAQs" />

      <div className="faq-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1 col-md-12">
              <div className="faq-accordion" id="accordion">
                {/* FAQ Item 1 */}
                <div
                  className="accordion-item wow fadeInUp"
                  data-wow-delay="0.25s"
                >
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      What is the Difference Between Frontend and Backend
                      Development?
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordion"
                  >
                    <div className="accordion-body">
                      <p>
                        Frontend development focuses on the user interface and
                        experience using HTML, CSS, and JavaScript. Backend
                        development handles server-side logic, databases, and
                        APIs using technologies like PHP, Python, Java, or
                        Node.js.
                      </p>
                    </div>
                  </div>
                </div>

                {/* FAQ Item 2 */}
                <div
                  className="accordion-item wow fadeInUp"
                  data-wow-delay="0.5s"
                >
                  <h2 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      What are APIs and How are They Used in Software
                      Development?
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordion"
                  >
                    <div className="accordion-body">
                      <p>
                        APIs (Application Programming Interfaces) allow
                        different software systems to communicate with each
                        other. They enable integrations, access to external
                        services, and modular application development.
                      </p>
                    </div>
                  </div>
                </div>

                {/* FAQ Item 3 */}
                <div
                  className="accordion-item wow fadeInUp"
                  data-wow-delay="0.75s"
                >
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      How Can I Improve My Software Development Skills?
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordion"
                  >
                    <div className="accordion-body">
                      <p>
                        You can improve your skills by practicing regularly,
                        learning modern frameworks, contributing to open-source
                        projects, staying updated with industry trends, and
                        building real-world applications.
                      </p>
                    </div>
                  </div>
                </div>

                {/* FAQ Item 4 */}
                <div
                  className="accordion-item wow fadeInUp"
                  data-wow-delay="1s"
                >
                  <h2 className="accordion-header" id="headingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      What are the Ethical Considerations in AI Development?
                    </button>
                  </h2>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFour"
                    data-bs-parent="#accordion"
                  >
                    <div className="accordion-body">
                      <p>
                        Ethical AI considerations include fairness,
                        transparency, accountability, privacy protection, and
                        reducing bias in AI systems.
                      </p>
                    </div>
                  </div>
                </div>

                {/* FAQ Item 5 */}
                <div
                  className="accordion-item wow fadeInUp"
                  data-wow-delay="1.25s"
                >
                  <h2 className="accordion-header" id="headingFive">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFive"
                      aria-expanded="false"
                      aria-controls="collapseFive"
                    >
                      What Engagement Models Do Software Companies Offer?
                    </button>
                  </h2>
                  <div
                    id="collapseFive"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFive"
                    data-bs-parent="#accordion"
                  >
                    <div className="accordion-body">
                      <p>
                        Common engagement models include fixed-price projects,
                        time & material billing, dedicated teams, staff
                        augmentation, and hybrid models.
                      </p>
                    </div>
                  </div>
                </div>

                {/* FAQ Item 6 */}
                <div
                  className="accordion-item wow fadeInUp"
                  data-wow-delay="1.5s"
                >
                  <h2 className="accordion-header" id="headingSix">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseSix"
                      aria-expanded="false"
                      aria-controls="collapseSix"
                    >
                      What Are Emerging Trends in the Software Industry?
                    </button>
                  </h2>
                  <div
                    id="collapseSix"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingSix"
                    data-bs-parent="#accordion"
                  >
                    <div className="accordion-body">
                      <p>
                        Key trends include cloud computing, AI & ML, IoT,
                        blockchain, low-code platforms, microservices, DevOps,
                        and advanced cybersecurity solutions.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
